import { lazy, Suspense } from "react";
import CircularLoader from "../../custom/circularLoader/circularLoader";
import DashboardLayout from "../dashboardLayout/dashboardLayout";

const Main = lazy(() => import("../../components/Practitioner/ApplicationForm/main"));

const ApplicationForm = () => {
    return (
        <DashboardLayout 
            heading="Application Form"
            paragraph="Fill in your details " 
        >
            <Suspense fallback={<CircularLoader/>}>
                <Main/>
            </Suspense>
        </DashboardLayout>
    )
}
export default ApplicationForm;